export const aboutStatic = {
  crumbs_nav: [
    { title_ua: 'Головна', title_ru: 'Главная', link: '/' },
    { title_ua: 'Про нас', title_ru: 'О нас', link: '/about/' },
  ],
};
